import StoreRow from './StoreRow'

export default StoreRow
